<div class="container terms-container">
    <div class="d-flex flex-column align-items-center mb-3">
        <h5>Terms and Conditions for Sketch - Online Electrical Design assit.</h5>
    </div>
    <p>
        These Terms and Conditions ("Terms") govern your use of the Sketch ("Application"), provided by Drawout
        ApS ("Company").
        By using the Application, you agree to comply with these Terms. If you do not agree with these Terms, please do
        not use the Application.
    </p>
    <h6>1. Acceptance of Terms</h6>
    <p>
        By using the Application, you acknowledge that you have read, understood, and agree to be bound by these Terms,
        as well as any applicable laws and regulations.
    </p>

    <h6>2. Use of the Application</h6>
    <p>2.1 The Application provides free access to electrical design templates for your convenience and reference.</p>
    <p>2.2 You may use the design templates for personal and commercial purposes. You are not allowed to sell,
        distribute, the templates without explicit permission from Drawout Engineering ApS

.</p>
    <p>2.3 Drawout Engineering ApS

 reserves the right to modify, suspend, or discontinue the Application or any part thereof at any
        time without notice.</p>

    <h6>3. Privacy and Data Collection</h6>
    <p>3.1 By using the Application, you agree to the collection, storage, and use of your personal information as
        outlined in our <a href="https://drawout.dk/assets/legal-informations/privacy-policy.pdf"
            target="_blank">Privacy Policy</a></p>
    <p>3.2 Drawout Engineering ApS

 may contact you for marketing purposes, including providing information about additional products
        and services. You can opt out of these communications at any time.</p>

    <h6>4. Intellectual Property</h6>
    <p>4.1 The design templates provided through the Application are the intellectual property of Drawout Engineering ApS

 and are
        protected by copyright laws.</p>
    <p>4.2 You may not reproduce, distribute, or create derivative works based on the design templates without explicit
        permission from Drawout Engineering ApS

.</p>

    <h6>5. Disclaimer of Warranty</h6>
    <p>5.1 Drawout Engineering ApS

 makes no warranties or representations about the accuracy or completeness of the design templates
        provided through the Application.</p>
    <p>5.2 The design templates are provided "as is" and Drawout Engineering ApS

 disclaims all warranties, whether express or
        implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and
        non-infringement.</p>

    <h6>6. Limitation of Liability</h6>
    <p>6.1 Drawout Engineering ApS

 shall not be liable for any direct, indirect, incidental, special, or consequential damages
        arising out of or in connection with your use of the Application or the design templates.</p>

    <h6>7. Indemnification</h6>
    <p>7.1 You agree to indemnify, defend, and hold harmless Drawout Engineering ApS

, its officers, directors, employees, and agents
        from and against any claims, liabilities, damages, losses, and expenses (including reasonable attorney fees)
        arising from your use of the Application or violation of these Terms.</p>

    <h6>8. Governing Law and Jurisdiction</h6>
    <p>8.1 These Terms and your use of the Application shall be governed by and construed in accordance with the laws of
        Denmark, without regard to its conflict of law principles.</p>
    <p>8.2 Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction
        of the courts of Aalborg, Denmark.</p>

    <h6>9. Changes to Terms</h6>
    <p>9.1 Drawout Engineering ApS

 reserves the right to modify or update these Terms at any time. Changes will be effective upon
        posting on the Application or sending notification to you.</p>

    <div class="mb-2 using-application">
        By using the Application, you confirm that you have read, understood, and agreed to these Terms and Conditions.
        If you do not agree to these Terms, please do not proceed with using the Application.
    </div>

    <div>
        For any questions or concerns regarding these Terms, please contact us at <a
            href="mailto:info@drawout.dk">info&#64;drawout.dk</a>
    </div>
</div>  